import { useEffect, useState } from "react";
import styles from "./ButtonSubmit.module.scss";
import { __callbacks } from "Utils/Callbacks/Callback";


export default function ButtonSubmit({
  submit,
  disable,
  onClick
}) {

  const [classDisable, setClassDisable] = useState(styles.disable);

  const listener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      //console.log("Enter key was pressed. Run your function.");
      document.removeEventListener("keydown", listener);
      event.preventDefault();
      onClick();
      
    }
  };

  __callbacks.onRemoveListener(() => {
    document.removeEventListener("keydown", listener);
});

  useEffect(() => {


    //console.log(disable);
    //console.log(submit);
  

    if (disable) {
      setClassDisable(styles.disable);
      
      document.removeEventListener("keydown", listener);
      return;
    }
    else {
      if (!submit) {
        document.addEventListener("keydown", listener);
      }
      
    }

    if (submit) {
     // console.log("We are removing listener")
      setClassDisable(styles.disable);
      document.removeEventListener("keydown", listener);
    }
    else {
      setClassDisable("");
    }

    

  }, [submit, disable]);


  useEffect(() => {

 
    //console.log(disable);
    //console.log(submit);
  

    if (disable) {
      setClassDisable(styles.disable);
      
      document.removeEventListener("keydown", listener);
      return;
    }


    

  }, []);

  

  return (
    <div className={`${styles.container} ${classDisable} config-btn-chat-form-submit`} onClick={onClick}>
      {
        (submit) ?
          (
            <div className={styles["content-sent"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M18.228 2.53001L19.8 4.10201L6.43001 17.47L0.200012 11.244L1.78201 9.67201L6.42801 14.318L18.228 2.53001Z" fill="gray" />
              </svg>&nbsp;Sent
            </div>

          ) :
          ("Submit")
      }
    </div>
  )
}
